var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c('div',{staticClass:"modal-errors",attrs:{"transition":"expand"}},_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"text-danger"},[_vm._v("\n        "+_vm._s(error)+"\n    ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }